































import Vue from 'vue'
import _ from 'lodash'
import { MESSAGING_LOAD_NEW_MESSAGES } from '@/store/action-types'
import { SystemMessage } from '@/model/messaging/Message'
import {
  MESSAGING_SET_MESSAGES_DATA_MUTATION,
  MESSAGING_SET_MENU_STATE,
  MESSAGING_SET_READ_MESSAGES_MUTATION
} from '@/store/mutation-types'
import { MESSAGING_GET_MESSAGES_LIST, MESSAGING_GET_READ_MESSAGES_LIST } from '@/store/getter-types'
import { ReviewedItem } from '@/types/payload'

interface ComponentData {
  activeTab: number
  messageItems: Array<SystemMessage>
  taskItems: Array<any>
  noteItems: Array<any>
  unreadStyle: Style
  readStyle: Style
  oldMessageList: Array<SystemMessage>
  showMessageList: boolean
}

interface Style {
  color: string
}

export default Vue.extend({
  name: 'Messaging',

  data (): ComponentData {
    return {
      activeTab: 0,
      messageItems: [],
      taskItems: [],
      noteItems: [],
      unreadStyle: { color: 'red' },
      readStyle: { color: '' },
      oldMessageList: [],
      showMessageList: false
    }
  },

  computed: {
    getWidth (): string {
      if(this.$vuetify.breakpoint.mdAndUp) {
        return '560px'
      } else if(this.$vuetify.breakpoint.sm) {
        return '500px'
      } else {
        return '300px'
      }
    },

    messagesList (): Array<SystemMessage> {
      const list: Array<SystemMessage> = _.cloneDeep(this.$store.getters[MESSAGING_GET_MESSAGES_LIST])
      const readMessageList: Array<SystemMessage> = list.filter((item: SystemMessage) => {
        return this.$store.getters[MESSAGING_GET_READ_MESSAGES_LIST].find((i: SystemMessage) => item.id === i.id)
      })

      this.$store.commit(MESSAGING_SET_READ_MESSAGES_MUTATION, readMessageList)

      this.$store.getters[MESSAGING_GET_READ_MESSAGES_LIST].forEach((item: SystemMessage) => {
        const foundItem: SystemMessage | undefined = list.find((i: SystemMessage) => i.id === item.id)

        if (foundItem) {
          const data: Array<ReviewedItem> = [
            {
              id: foundItem.id,
              message: foundItem.message,
              date: foundItem.date,
              color: foundItem.color,
              reviewed: true
            }
          ]
          const reviewedItem: SystemMessage = SystemMessage.createListFromData(data)[0]
          list.splice(list.indexOf(foundItem), 1, reviewedItem)
        }
      })
      return list
    }
  },

  watch: {
    messagesList (newVal) {
      if (newVal && newVal.length > 0) {
        this.showMessageList = true
        if (_.differenceBy(newVal, this.oldMessageList, 'id').length > 0)
          this.$store.commit(MESSAGING_SET_MENU_STATE, true)
        this.oldMessageList = newVal
      } else {
        this.showMessageList = false
      }
    }
  },

  methods: {
    onMessageItemClick (item: SystemMessage): void {
      const list: Array<SystemMessage> = _.cloneDeep(this.$store.getters[MESSAGING_GET_MESSAGES_LIST])
      const readMessageList: Array<SystemMessage> = this.$store.getters[MESSAGING_GET_READ_MESSAGES_LIST]
      const foundItem: SystemMessage | undefined = list.find((i: SystemMessage) => i.id === item.id)

      if (foundItem) {
        const data: Array<ReviewedItem> = [
          {
            id: foundItem.id,
            message: foundItem.message,
            date: foundItem.date,
            color: foundItem.color,
            reviewed: !foundItem.reviewed
          }
        ]
        const reviewedItem: SystemMessage = SystemMessage.createListFromData(data)[0]
        list.splice(list.indexOf(foundItem), 1, reviewedItem)

        if (reviewedItem.reviewed === true) {
          readMessageList.push(reviewedItem)
          this.$store.commit(MESSAGING_SET_READ_MESSAGES_MUTATION, readMessageList)
        } else {
          const foundReadItem: SystemMessage | undefined = readMessageList.find((i: SystemMessage) => i.id === foundItem.id)
          if (foundReadItem) {
            readMessageList.splice(readMessageList.indexOf(foundReadItem), 1)
            this.$store.commit(MESSAGING_SET_READ_MESSAGES_MUTATION, readMessageList)
          }
        }
        this.$store.commit(MESSAGING_SET_MESSAGES_DATA_MUTATION, list)
      }
    },

    onUnreadClick (item: SystemMessage) {
      const list: Array<SystemMessage> = _.cloneDeep(this.$store.getters[MESSAGING_GET_MESSAGES_LIST])
      const readMessageList: Array<SystemMessage> = this.$store.getters[MESSAGING_GET_READ_MESSAGES_LIST]
      const foundItem: SystemMessage | undefined = list.find((i: SystemMessage) => i.id === item.id)

      if (foundItem) {
        const data: Array<ReviewedItem> = [
          {
            id: foundItem.id,
            message: foundItem.message,
            date: foundItem.date,
            color: foundItem.color,
            reviewed: false
          }
        ]
        const reviewedItem: SystemMessage = SystemMessage.createListFromData(data)[0]
        list.splice(list.indexOf(foundItem), 1, reviewedItem)

        const foundReadItem: SystemMessage | undefined = readMessageList.find((i: SystemMessage) => i.id === foundItem.id)
        if (foundReadItem) {
          readMessageList.splice(readMessageList.indexOf(foundReadItem), 1)
          this.$store.commit(MESSAGING_SET_READ_MESSAGES_MUTATION, readMessageList)
        }

        this.$store.commit(MESSAGING_SET_MESSAGES_DATA_MUTATION, list)
      }
    }
  },

  async mounted () {

    const messagesList = await this.$store.dispatch(MESSAGING_LOAD_NEW_MESSAGES)

    this.$store.commit(MESSAGING_SET_MESSAGES_DATA_MUTATION, messagesList)
  }
})
